// TODO: Check whether this is in use, possibly delete this functionality
import { Button, Card, Input } from "@rumbledirect/ui";
import { Form, message, Typography } from "antd";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { createServicePartnerChangeRequest } from "@/lib/api/resources/servicePartners";
import { useNavigate, useParams } from "react-router-dom";
import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";
import { Address } from "@rumble-it/common-lib/types/common/Address.interface";

type FormValues = {
  groupName: string;
  name: string;
  email: string;
  telephone: string;
  address: Address;
};

interface Props {
  servicePartner: ServicePartner | undefined;
  loading?: boolean;
}

export const ServicepartnerChangeRequestForm = ({
  servicePartner,
  loading,
}: Props) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      groupName: "",
      name: "",
      email: "",
      telephone: "",
      address: {
        street: "",
        streetNumber: "",
        streetNumberAddition: "",
        postalCode: "",
        city: "",
      },
    },
  });

  const mutation = useMutation({
    mutationFn: async (payload: any) =>
      createServicePartnerChangeRequest(id as string, payload),
    onSuccess: () => {
      message.success("Wijzigingsverzoek is ingediend");
      navigate(`/service-partners/partners/${id}`);
    },
    onError: () =>
      message.error(
        "Er is iets misgegaan bij het indienen van het wijzigingsverzoek.",
      ),
  });

  const toNullIfEmpty = (value: string | undefined) =>
    value?.trim() ? value : null;

  const isAllNull = (obj: any): boolean =>
    Object.values(obj).every(
      (v) =>
        v === null ||
        v === undefined ||
        (typeof v === "object" && v !== null && isAllNull(v)),
    );

  const onSubmit = (values: FormValues) => {
    const address = Object.fromEntries(
      Object.entries(values.address).map(([key, value]) => [
        key,
        toNullIfEmpty(value),
      ]),
    );
    const addressIsNull = isAllNull({
      ...address,
      streetNumberAddition: undefined,
    });

    const payload = {
      groupName: toNullIfEmpty(values.groupName),
      name: toNullIfEmpty(values.name),
      email: toNullIfEmpty(values.email),
      telephone: toNullIfEmpty(values.telephone),
      address: addressIsNull ? null : address,
    } as const;

    if (isAllNull(payload)) {
      message.info("Geen wijzigingen gemaakt");
      return;
    }

    mutation.mutate(payload);
  };

  return (
    <Card loading={loading} title="Wijziging basisgegevens aanvragen">
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <Form.Item
          label={
            <div>
              <div>Groep Naam</div>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Huidige waarde: {servicePartner?.groupName || "-"}
              </Typography.Text>
            </div>
          }
        >
          <Controller
            name="groupName"
            control={control}
            render={({ field }) => <Input {...field} />}
          />
        </Form.Item>

        <Form.Item
          label={
            <div>
              <div>Naam</div>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Huidige waarde: {servicePartner?.name || "-"}
              </Typography.Text>
            </div>
          }
        >
          <Controller
            name="name"
            control={control}
            render={({ field }) => <Input {...field} />}
          />
        </Form.Item>

        <Form.Item
          label={
            <div>
              <div>E-mailadres</div>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Huidige waarde: {servicePartner?.email || "-"}
              </Typography.Text>
            </div>
          }
        >
          <Controller
            name="email"
            control={control}
            render={({ field }) => <Input {...field} />}
          />
        </Form.Item>

        <Form.Item
          label={
            <div>
              <div>Telefoonnummer</div>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Huidige waarde: {servicePartner?.telephone || "-"}
              </Typography.Text>
            </div>
          }
        >
          <Controller
            name="telephone"
            control={control}
            render={({ field }) => <Input {...field} />}
          />
        </Form.Item>

        <Form.Item
          label={
            <div>
              <div>Adres</div>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Huidige waarde:{" "}
                {servicePartner?.address
                  ? `${servicePartner?.address.street ?? ""} ${servicePartner?.address.streetNumber ?? ""}${servicePartner?.address.streetNumberAddition ?? ""}, ${servicePartner?.address.postalCode ?? ""} ${servicePartner?.address.city ?? ""}`
                  : "Niet ingesteld"}
              </Typography.Text>
            </div>
          }
        >
          <Form.Item label="Straat" name={"address.street"}>
            <Controller
              name="address.street"
              control={control}
              render={({ field }) => <Input {...field} />}
            />
          </Form.Item>
          <Form.Item label="Huisnummer" name={"address.streetNumber"}>
            <Controller
              name="address.streetNumber"
              control={control}
              render={({ field }) => <Input {...field} />}
            />
          </Form.Item>
          <Form.Item label="Toevoeging" name={"address.streetNumberAddition"}>
            <Controller
              name="address.streetNumberAddition"
              control={control}
              render={({ field }) => (
                <Input {...field} value={field.value ?? ""} />
              )}
            />
          </Form.Item>
          <Form.Item label="Postcode" name={"address.postalCode"}>
            <Controller
              name="address.postalCode"
              control={control}
              render={({ field }) => <Input {...field} />}
            />
          </Form.Item>
          <Form.Item label="Stad" name={"address.city"}>
            <Controller
              name="address.city"
              control={control}
              render={({ field }) => <Input {...field} />}
            />
          </Form.Item>
        </Form.Item>

        <Form.Item>
          <Button
            type="default"
            onClick={() => navigate(-1)}
            style={{ marginRight: 8 }}
          >
            Annuleren
          </Button>
          <Button type="primary" htmlType="submit" loading={mutation.isPending}>
            Wijziging aanvragen
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
